var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [(_vm.$route.meta.keepAlive)?_c('keep-alive',[_c(Component,{tag:"Component"})],1):_c(Component,{tag:"Component"})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }